import React from 'react';
import classnames from 'classnames';
import enhanceWithClickOutside from 'react-click-outside';
import { isBrowser } from 'react-device-detect';
import { translate } from 'react-i18next';

import Options from 'components/atoms/Options';
import Triangle from 'components/atoms/Triangle';

import styles from './index.css';

class HeaderSelect extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			optionsOpen: false,
			hoveredRegion: null,
		};
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.toggleSelectBox = this.toggleSelectBox.bind(this);
	}

	onSelect(option) {
		this.setState({ optionsOpen: false });
		this.props.onSelect(option);
	}

	handleClickOutside() {
		this.setState({ optionsOpen: false });
	}

	toggleSelectBox() {
		if (!this.props.disabled) {
			this.setState({ optionsOpen: !this.state.optionsOpen });
		}
	}

	render() {
		const {
			className,
			options,
			placeholder = 'select...',
			PlaceholderIcon,
			selected = {
				id: -1,
				label: '',
				value: '',
			},
			disabled,
			selectBoxConfig: selectBoxConfigProp,
			optionConfig: optionConfigProp,
			moreWeight,
			t,
		} = this.props;

		// 將 options 分成台灣和日本的選項 (作為 #175 的 workaround 解決方案 只在這邊簡單作陣列區分而非更改整個 redux 資料邏輯)
		// src/util/hotel.js 的 options 陣列最後一個元素是日本選項，所以需要分開處理
		const mainOption = options.length && options[0].value === 'main' ? [options[0]] : [];
		const lastOption = options.length ? [options[options.length - 1]] : [];
		const taiwanOptions = options.length ? options.slice(0, -1) : []; // 除了最後一個元素的陣列
		const japanOptions = [...mainOption, ...lastOption]; // 包含第一個 main 選項和最後一個日本選項

		// console.log('options:', options);
		// console.log('Japan Options:', japanOptions);
		// console.log('Taiwan Options:', taiwanOptions);

		const selectBoxConfig = {
			class: styles.defaultSelectBox,
			activeClass: styles.activeSelectBox,
			triangle: true,
			triangleDown: false,
			triangleSize: 10,
			triangleColor: '#2D2926',
			triangleBorderWidth: 1,
			animation: false,
			...selectBoxConfigProp,
		};

		const optionConfig = { border: true, ...optionConfigProp };

		const { optionsOpen } = this.state;

		return (
			<div
				className={classnames(styles.select, className, {
					[styles.disabled]: disabled,
				})}
			>
				<div
					className={classnames(styles.selectBox, selectBoxConfig.class, {
						[styles.active]: optionsOpen,
						[selectBoxConfig.activeClass]: optionsOpen,
						[styles.animation]: selectBoxConfig.animation,
						[styles.isBrowser]: isBrowser,
					})}
					role="button"
					tabIndex="0"
					onClick={this.toggleSelectBox}
					onKeyPress={() => {}}
				>
					<div className={styles.mask} />
					<div className={styles.container}>
						{selected.id === -1 ? (
							<div className={styles.placeholder}>
								{PlaceholderIcon && (
									<div className={styles.icon}>
										<PlaceholderIcon />
									</div>
								)}
								<div className={styles.text}>{placeholder}</div>
							</div>
						) : (
							selected.label
						)}
						{selectBoxConfig.triangle && (
							<Triangle
								direction={selectBoxConfig.triangleDown || optionsOpen ? 'down' : 'right'}
								className={styles.triangle}
								size={selectBoxConfig.triangleSize}
								color={selectBoxConfig.triangleColor}
								borderWidth={selectBoxConfig.triangleBorderWidth}
							/>
						)}
					</div>
				</div>
				<div
					className={classnames(styles.options)}
					style={{ height: optionsOpen ? `${options.length * 60}px` : 0 }}
				>
					<div
						className={styles.regionOptions}
						onMouseEnter={() => this.setState({ hoveredRegion: 'taiwan' })}
						onMouseLeave={() => this.setState({ hoveredRegion: null })}
					>
						<div className={styles.regionTitle}>{t('taiwan')}</div>
						{this.state.hoveredRegion === 'taiwan' && (
							<Options
								options={taiwanOptions}
								selected={selected}
								onSelect={this.onSelect}
								moreWeight={moreWeight}
								{...optionConfig}
							/>
						)}
					</div>
					<div
						className={styles.regionOptions}
						onMouseEnter={() => this.setState({ hoveredRegion: 'japan' })}
						onMouseLeave={() => this.setState({ hoveredRegion: null })}
					>
						<div className={styles.regionTitle}>{t('japan')}</div>
						{this.state.hoveredRegion === 'japan' && (
							<Options
								options={japanOptions}
								selected={selected}
								onSelect={this.onSelect}
								moreWeight={moreWeight}
								{...optionConfig}
							/>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default translate('header')(enhanceWithClickOutside(HeaderSelect));



// WEBPACK FOOTER //
// ./src/components/atoms/HeaderSelect/index.js